<div class="upp-numpad no-select">
    <div class="upp-numpad__row">
        <ion-button uppDataid="numpad_7" class="upp-numpad__key"
            fill="solid"
            color="light"
            (click)="OnKey(7)"
        >7</ion-button>
        <ion-button uppDataid="numpad_8" class="upp-numpad__key"
            fill="solid"
            color="light"
            (click)="OnKey(8)"
        >8</ion-button>
        <ion-button uppDataid="numpad_9" class="upp-numpad__key"
            fill="solid"
            color="light"
            (click)="OnKey(9)"
        >9</ion-button>
    </div>
    <div class="upp-numpad__row">
        <ion-button uppDataid="numpad_4" class="upp-numpad__key"
            fill="solid"
            color="light"
            (click)="OnKey(4)"
        >4</ion-button>
        <ion-button uppDataid="numpad_5" class="upp-numpad__key"
            fill="solid"
            color="light"
            (click)="OnKey(5)"
        >5</ion-button>
        <ion-button uppDataid="numpad_6" class="upp-numpad__key"
            fill="solid"
            color="light"
            (click)="OnKey(6)"
        >6</ion-button>
    </div>
    <div class="upp-numpad__row">
        <ion-button uppDataid="numpad_1" class="upp-numpad__key"
            fill="solid"
            color="light"
            (click)="OnKey(1)"
        >1</ion-button>
        <ion-button uppDataid="numpad_2" class="upp-numpad__key"
            fill="solid"
            color="light"
            (click)="OnKey(2)"
        >2</ion-button>
        <ion-button uppDataid="numpad_3" class="upp-numpad__key"
            fill="solid"
            color="light"
            (click)="OnKey(3)"
        >3</ion-button>
    </div>
    <div class="upp-numpad__row upp-numpad__row--bottom">
        <ion-button uppDataid="numpad_0" class="upp-numpad__key"
            fill="solid"
            color="light"
            (click)="OnKey(0)"
        >0</ion-button>
        <ion-button uppDataid="numpad_go" class="upp-numpad__key upp-numpad__key--confirm"
            fill="clear"
            color="success"
            [disabled]="disabled"
            [class.upp-numpad__key--confirm-disabled]="disabled"
            (click)="OnAccept()"
        >
            <ion-icon name="checkmark-circle-outline"></ion-icon>
        </ion-button>
        <ion-button uppDataid="numpad_B" class="upp-numpad__key"
            fill="solid"
            color="light"
            (click)="OnKey('Backspace')"
        >
            <ion-icon name="backspace-outline"></ion-icon>
        </ion-button>
    </div>
</div>
